module.exports = __webpack_public_path__ + "img/06.166e4754.jpg";